import React, { useRef, useState } from "react";
import CommonDropdown from "../CommonDropdown";
import GoogleReview from "./GoogleReview";
import GeneralReview from "./ReviewFromWebApp";
import FormalReview from "./FormalReview";
import MobileReview from "./MobileReview";
import { useDispatch, useSelector } from "react-redux";

import CustomerStatisfactionCards from "./CustomerStatisfactionCards";
import Map from "../../MapContienent";
import { printDocument } from "../../../ChartsJs/DownlaodExportImage";

const CustomerStatisfaction = () => {
  const { ReviewCardData, getReviewData } = useSelector(
    (state) => state.reviews
  );
  const { selectedMonth, refresh, type, year, metrics } = useSelector(
    (state) => state.revenue
  );
  const [GeoShow, setGeoShow] = useState(false);

  const CustomerSatisfactionRef = useRef();
  const handlePrintDocument = () => {
    const orientation = "Landscape";
    printDocument(CustomerSatisfactionRef, "CustomerSatisfaction", orientation);
  };
  return (
    <>
      <button
        className="pfdexportIcon"
        onClick={handlePrintDocument}
        title="Download Full Screen"
      >
        <i className="lar la-file-pdf"></i>
      </button>
      <div className="pdfContent" ref={CustomerSatisfactionRef}>
        <div className="page-header">
          <div className="row">
            <div className="col-sm-3">
              <h3 className="page-title">Customer Statisfaction</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">
                  Customer Statisfaction
                </li>
              </ul>
            </div>
            <div className="col-sm-9">
              <CommonDropdown
                IsNotShow={true}
                csStatisfaction={true}
                setGeoShow={setGeoShow}
              />
            </div>
          </div>
        </div>

        <div className="row six-cols">
          <CustomerStatisfactionCards
            year={year}
            type={metrics.type}
            filter={metrics.filter}
            metric={metrics.metrices}
            metricvalue={metrics.metricesValue}
          />
        </div>
        {!GeoShow && (
          <>
            <div className="row">
              <div className="col-md-6">
                <GoogleReview
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                <GeneralReview
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>

              <div className="col-md-6">
                {" "}
                <FormalReview
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>
              <div className="col-md-6">
                <MobileReview
                  year={year}
                  type={metrics.type}
                  filter={metrics.filter}
                  metric={metrics.metrices}
                  metricvalue={metrics.metricesValue}
                />
              </div>
            </div>
          </>
        )}
        {GeoShow && <Map />}
      </div>
    </>
  );
};

export default CustomerStatisfaction;
